var map = {
	"./account-white.svg": "3295",
	"./add-white.svg": "431c",
	"./api-white.svg": "6b84",
	"./arrow-right-filled-white.svg": "2a7f",
	"./back-white.svg": "addf",
	"./check-white.svg": "5131",
	"./close-white.svg": "72e4",
	"./coins-white.svg": "6a24",
	"./coins3-white.svg": "9c5e",
	"./copy-white.svg": "d787",
	"./crypto-dent-white.svg": "8ddc",
	"./dashboard2-white.svg": "605f",
	"./docs-white.svg": "0655",
	"./download-white.svg": "d959",
	"./earn-coin-white.svg": "6343",
	"./esim-white.svg": "05ed",
	"./eye-visible-white.svg": "4a52",
	"./globe-nav-chevron-right-white.svg": "032c",
	"./graph-bar-white.svg": "046f",
	"./investment-history-white.svg": "0407",
	"./lock-open-white.svg": "7f23",
	"./logout-white.svg": "aa8d",
	"./market-place-white.svg": "4ae7",
	"./plus-white.svg": "7e53",
	"./present-white.svg": "e907",
	"./rocketman-white.svg": "6132",
	"./sdk-white.svg": "975a",
	"./share-white.svg": "b943",
	"./shopping-cart-white.svg": "dd76",
	"./wallet-white.svg": "52cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88a1";